var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table",attrs:{"id":"table"}},[_c('Table',{staticClass:"table-div",attrs:{"height":_vm.tableHeight,"border":_vm.tableData && _vm.tableData.length > 0,"stripe":"","columns":_vm.tableColumn,"data":_vm.tableData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }